/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const itemDependencyStateSchema = z.object({
  atRiskPredecessorIds: z
    .array(z.int())
    .describe('Predecessor item ids causing this item to be at risk'),
  blockedByPredecessorIds: z
    .array(z.int())
    .describe('Predecessor item ids causing this item to be blocked'),
  status: z
    .enum(['NO_ISSUE', 'AT_RISK', 'BLOCKED', 'CANNOT_EVALUATE'])
    .describe('Dependency state derived from predecessor status'),
});
